<div class="center-content">
    <img src="/assets/missoula-osteopathic-clinic-new-logo-cropped-r2de9l47vd7x3i91ovtn5aqyyjm4fjapttn9e3jfgg.png">
    <div class="standout-title">Rate your joints!</div>
    Your regenerative health journey starts with a rating your current joint condition.
</div>   
<div class="center-content">
    <div class="button-text-grid">
        <div class="button-cell">
            <a class="button fancy-button" routerLink="/questions" routerLinkActive="active" title="Questions">
                <i class="material-icons">assignment</i>
                <span>Questions</span>
            </a>
        </div>
        <div class="text-cell">
            <p>Please select Questions to rate your joints.</p>
        </div>

        <div class="button-cell">
            <a class="button fancy-button" routerLink="/results" routerLinkActive="active" title="View Results">
                <i class="material-icons">list</i>
                <span>Results</span>
            </a>
        </div>
        <div class="text-cell">
            <p>When complete, the Results can be viewed. You will have the option to forward to the clinic.</p>
        </div>
    </div>
</div>